<template>
  <div class="invoice-totals dbox">
    <div class="dt-list">
      <div class="dt-list-item">
        <div class="dt-list-item--column">
          {{$t('net_amount')}}
        </div>
        <div class="dt-list-item--column">
           {{selectedInvoice.invoice.net_amount}} {{selectedInvoice.invoiceCurrency.currency_iso}}
        </div>
      </div>
      <div class="dt-list-item">
        <div class="dt-list-item--column">
          {{$t('vat')}}
        </div>
        <div class="dt-list-item--column">
           {{selectedInvoice.invoice.vat1_amount}} {{selectedInvoice.invoiceCurrency.currency_iso}}
        </div>
      </div>
      <div class="dt-list-item">
        <div class="dt-list-item--column">
          {{$t('gross_amount')}}
        </div>
        <div class="dt-list-item--column">
           {{selectedInvoice.invoice.gross_amount}} {{selectedInvoice.invoiceCurrency.currency_iso}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { EventHooks } from '../../../../plugins/text-field';
import { createCountriesTV } from '../../../../models/country.model';
import { createLanguageTV } from '../../../../models/language.model';
import { tv } from '../../../../models/text-value.model';
import { createUserTV } from '../../../../models/user.model';
import DatePicker from '@plugins/text-field/date-picker';
import { createCurrencyTV } from '../../../../models/currency.model';

export default {
  components: {
    DatePicker
  },
  props: {
    selectedInvoice: {
      required: true,
    },
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
    }
  },
}
</script>

<style lang="scss" scoped>

.dt-list {
  .dt-list-item {
    .dt-list-item--column:nth-child(2) {
      margin-right: 10px;
      text-align: right;
    }
  }
}

</style>
